import type { DashboardKpis } from '@shared/types/dashboard';
import { api } from './client';

export async function getDashboardKpis(): Promise<DashboardKpis> {
  return api.get<DashboardKpis>('/api/dashboard/kpis');
}
